"use strict";

module.exports = function (val) {
  var newVal = parseInt(val, 10) / 4;

  if (newVal === 1) {
    return '1 Set';
  }

  return "".concat(newVal, " Sets");
};